import React from 'react';
import Intercom from './components/Intercom';

const Plugins = () => {
  return <>{process.env.REACT_APP_INTERCOM && <Intercom />}</>;
};

export default Plugins;
